document.addEventListener('DOMContentLoaded', function() {
    if (document.title.toLowerCase().includes('certificates of analysis')
        && document.title.toLowerCase() !== 'certificates of analysis – media bros') {
        const pageContents = document.querySelectorAll('.page__content.rte');
        const pageContentATags = document.querySelectorAll('.page__content.rte a');
        
        pageContents.forEach(pageContent => {
            pageContent.style.marginTop = '70px';
        });
        pageContentATags.forEach(aTag => {
            aTag.setAttribute('target', '_blank');
        });
    }
});